import AuthResultLayout from "layout/auth-result-layout/AuthResultLayout";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const PAGE_LOCALE_KEY = "page.changePassword.resultPage.";

const ChangePasswordResult = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <AuthResultLayout
      title={t(PAGE_LOCALE_KEY + "title")}
      content={[
        t(PAGE_LOCALE_KEY + "content-1"),
        t(PAGE_LOCALE_KEY + "content-2"),
      ]}
      buttonText={t(PAGE_LOCALE_KEY + "button")}
      buttonAction={() => navigate("/user/login", { replace: true })}
      countdown={5}
    />
  );
};

export default ChangePasswordResult;
